/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

//import axios from '@/axios.js';
import firebase, { readSaleReport } from '@/services/saleData';
import { invalidateReport, currentReport } from '@/services/reportRange';
import 'firebase/database';
import 'firebase/firestore';
//import router from '@/router';
import moment from "moment-timezone";
import _ from 'lodash';
import axios from 'axios';
export default {
  async getCompareDepositAndWithdraw({commit}){
    const lastmonth = moment().tz("Asia/Bangkok").subtract(1, 'months').format('YYYY-MM-')+'01';
    const lastmonth2 = moment().tz("Asia/Bangkok").subtract(1, 'months').format('MM');
    //const thismonth = moment().tz("Asia/Bangkok").format('YYYY-MM-')+'01';
    const depositThisMonth = [];
    const depositLastMonth = [];
    const withdrawThisMonth = [];
    const withdrawLastMonth = [];
    const activeThisMonth = [];
    const activeLastMonth = [];
    const totalLastMonth =[];
    const totalThisMonth =[];
    let depthismonth = 0;
    let deplastmonth = 0;
    let withthismonth = 0;
    let withlastmonth = 0;
    let actlastmonth = 0;
    let actthismonth = 0;
    let tollastmonth = 0;
    let tolthismonth = 0;
    await firebase.firestore().collection("krungsri_today").where('date','>=',`${lastmonth}`).orderBy('date').get().then((query)=>{
      query.forEach((doc) => {
        if(doc.data().type === 'deposit'){
          const d  = doc.data().date.split('-');
          if(d[1] === lastmonth2){
            depositLastMonth.push(doc.data().value);
            deplastmonth += doc.data().value;
          }else{
            depositThisMonth.push(doc.data().value);
            depthismonth += doc.data().value;
          }
        }else if(doc.data().type === 'withdraw'){
          const d  = doc.data().date.split('-');
          if(d[1] === lastmonth2){
            withdrawLastMonth.push(doc.data().value);
            withlastmonth += doc.data().value;
          }else{
            withdrawThisMonth.push(doc.data().value);
            withthismonth += doc.data().value;
          }
        }else if(doc.data().type === 'active'){
          const d  = doc.data().date.split('-');
          if(d[1] === lastmonth2){
            activeLastMonth.push(doc.data().value);
            actlastmonth += doc.data().value;
          }else{
            activeThisMonth.push(doc.data().value);
            actthismonth += doc.data().value;
          }
        }
      });
      for(const x in depositThisMonth){
        let total = 0;
        if(withdrawThisMonth[x]){
          total = depositThisMonth[x]-withdrawThisMonth[x];
        }else{
          total = depositThisMonth[x];
        }
        totalThisMonth.push(total);
        tolthismonth += total;
      }
      for(const x in depositLastMonth){
        const total = depositLastMonth[x]-withdrawLastMonth[x];
        totalLastMonth.push(total);
        tollastmonth += total;
      }
    });

    console.log('tolthismonth',tolthismonth);
    commit('SET_DEPOSITCOMPARE',{
      analyticsData: {
        thisMonth: depthismonth,
        lastMonth: deplastmonth
      },
      series: [
        {
          name: 'This Month',
          data: depositThisMonth
        },
        {
          name: 'Last Month',
          data: depositLastMonth
        }
      ]
    });
    commit('SET_WITHDRAWCOMPARE',{
      analyticsData: {
        thisMonth: withthismonth,
        lastMonth: withlastmonth
      },
      series: [
        {
          name: 'This Month',
          data: withdrawThisMonth
        },
        {
          name: 'Last Month',
          data: withdrawLastMonth
        }
      ]
    });
    commit('SET_ACTIVECOMPARE',{
      analyticsData: {
        thisMonth: actthismonth,
        lastMonth: actlastmonth
      },
      series: [
        {
          name: 'This Month',
          data: activeThisMonth
        },
        {
          name: 'Last Month',
          data: activeLastMonth
        }
      ]
    });
    commit('SET_TOTALCOMPARE',{
      analyticsData: {
        thisMonth: tolthismonth,
        lastMonth: tollastmonth
      },
      series: [
        {
          name: 'This Month',
          data: totalThisMonth
        },
        {
          name: 'Last Month',
          data: totalLastMonth
        }
      ]
    });
  },
  async getDeposit30({commit,rootState}){
    const email = rootState.AppActiveUser.email.split('@')[0];
    const users = (await firebase.database().ref(`/users`).orderByChild('code').equalTo(email.toUpperCase()).once('value')).val();
    const user = users && users[Object.keys(users)[0]];
    if (!user) return;
    if(user.partner){
      const date = moment().tz("Asia/Bangkok").add(-30,'days').format("YYYY-MM-DD");
      firebase.firestore().collection("krungsri_today").where('date','>=',`${date} 00:00`).orderBy('date').get().then((query)=>{
        const deposit = [];
        const active = [];
        const withdraw = [];
        const bonus = [];
        query.forEach((doc) => {
          if(doc.data().type === 'deposit'){
            deposit[doc.data().date] = doc.data().value;
          }else
          if(doc.data().type === 'withdraw'){
            withdraw[doc.data().date] = doc.data().value;
          }else if(doc.data().type === 'bonus'){
            bonus[doc.data().date] = doc.data().value;
          }else{
            active[doc.data().date] = doc.data().value;
          }
        });
        
        const keys = Object.keys(deposit);
        const sortedKeys = _.sortBy(keys);
      
        const d2= _.fromPairs(
          _.map(sortedKeys, key => [key, deposit[key]])
        )
        let i=0;
        const response = [];
        for(const x in d2){
          response[i] = d2[x].toFixed(0);
          i++;
        }
        const series = [
          {
            name: 'ฝาก',
            data: response
          }
        ];
        commit('SET_DEPOSIT30',series);


        i=0;
        const response2 = [];
        for(const x in withdraw){
          response2[i] = withdraw[x].toFixed(0);
          i++;
        }
        const series2 = [
          {
            name: 'ถอน',
            data: response2
          }
        ];
        commit('SET_WITHDRAW30',series2);

        i=0;
        const response3 = [];
        for(const x in active){
          response3[i] = active[x].toFixed(0);
          i++;
        }
        const series3 = [
          {
            name: 'ผู้ใช้',
            data: response3
          }
        ];
        commit('SET_ACTIVE30',series3);

        i=0;
        const response4 = [];
        for(const x in bonus){
          response4[i] = bonus[x].toFixed(0);
          i++;
        }
        const series4 = [
          {
            name: 'Bonus',
            data: response4
          }
        ];
        commit('SET_BONUS30',series4);
      });
    }
    
  },
  /*getWithdraw30({commit}){
    const date = moment().tz("Asia/Bangkok").add(-30,'days').format("YYYY-MM-DD");
    firebase.firestore().collection("history").where('createdate','>=',`${date} 00:00`).where('type','==','ถอน').where('status','==','ดำเนินการแล้ว').get().then((query)=>{
      const value = [];
      query.forEach((doc) => {
        const d = doc.data().createdate.split(' ');
        if(value[d[0]] === undefined){
          value[d[0]] = 0;
        }
        value[d[0]] += Math.round(Number(doc.data().qty.toString().replace(/,/g,'')));
      });
      const keys = Object.keys(value)
      const sortedKeys = _.sortBy(keys);
    
      const d2= _.fromPairs(
        _.map(sortedKeys, key => [key, value[key]])
      )
      let i=0;
      const response = [];
      for(const x in d2){
        response[i] = d2[x];
        i++;
      }
      const series = [
        {
          name: 'ถอน',
          data: response
        }
      ];
      commit('SET_WITHDRAW30',series);
    });
  },*/
  getActive30({commit}){
    const date = moment().tz("Asia/Bangkok").add(-30,'days').format("YYYY-MM-DD");
    firebase.firestore().collection('login').where('login','>=',date+' 00:00:00').get().then(querySnapshot => {
      const value = [];
      querySnapshot.forEach((doc) => {
        const d = doc.data().login.split(' ');
        if(value[d[0]] === undefined){
          value[d[0]] = 0;
        }
        value[d[0]] += 1;
      });
      const keys = Object.keys(value)
      const sortedKeys = _.sortBy(keys);
    
      const d2= _.fromPairs(
        _.map(sortedKeys, key => [key, value[key]])
      )
      let i=0;
      const response = [];
      for(const x in d2){
        response[i] = d2[x];
        i++;
      }
      const series = [
        {
          name: 'ผู้ใช้',
          data: response
        }
      ];
      commit('SET_ACTIVE30',series);
    });
      
    /*
    series: [
      {
        name: 'ถอน',
        data: [28, 40, 36, 52, 38, 60, 55,28, 40, 36, 52, 38, 60, 55]
      }
    ],
    */
  },
  invalidateHistory({state}) { invalidateReport(state); },
  async getHistory({rootState,commit,state},{startdate,enddate}) {
    const generation = invalidateReport(state);
    const account = firebase.auth().currentUser;
    if (!account) throw new Error('กรุณาเข้าสู่ระบบใหม่');
    const result = await readSaleReport('dashboard', startdate, enddate);
    const current = firebase.auth().currentUser;
    if (!currentReport(state, generation) || !current || current.uid !== account.uid) return {applied: false};
    const data = result.summary;
    commit('SET_KRUNGSRI', data.krungsri);
    commit('SET_WITHDRAW', data.withdraw);
    commit('SET_DEPOSIT', data.deposit);
    commit('SET_ACTIVEUSERS', data.usersactive);
    commit('SET_FIRSTCREDIT_NEW', data.firstcreditNew);
    commit('SET_FIRSTCREDIT_OLD', data.firstcreditOld);
    return {applied: true, percent: data.percent};
  },
  async updateStatement({ state,commit,rootState },{selected,bonus}){
    const users = state.users;
    const statementUser = state.statementUser;
    let credit = Math.floor(statementUser.qty.replace(',',''));
    if(bonus){
      let b = Math.floor(bonus.replace(',',''));
      credit = Number(credit.toString().replace(',',''))+Number(b.toString().replace(',',''));
    }
    firebase.firestore().collection("history").doc(users[selected].key).update({
      status:'ดำเนินการแล้ว',
      updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
      employee:rootState.AppActiveUser,
      bonus,
    });
    firebase.firestore().collection("krungsri").doc(statementUser.key).update({
      status:'ดำเนินการแล้ว',
      updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
      employee:rootState.AppActiveUser,
      bonus,
    });
    axios({
      method: "post",
      url: "https://api.ufaeasy888.com/addcredit",
      data: {
        userId: users[selected].userId,
        credit
      }
    }).then(async response => {
      if (response.data && response.data.status) {
        console.log(response.data);
      }else{
        firebase.firestore().collection("history").doc(users[selected].key).update({
          status:'กำลังดำเนินการ',
          updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
          employee:rootState.AppActiveUser,
        });
        firebase.firestore().collection("krungsri").doc(statementUser.key).update({
          status:'ไม่สามารถเพิ่ม credit ได้',
          updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
          employee:rootState.AppActiveUser,
        });
      }
    })
    .catch(function() {
      firebase.firestore().collection("history").doc(users[selected].key).update({
        status:'กำลังดำเนินการ',
        updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        employee:rootState.AppActiveUser,
      });
      firebase.firestore().collection("krungsri").doc(statementUser.key).update({
        status:'ไม่สามารถเพิ่ม credit ได้',
        updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        employee:rootState.AppActiveUser,
      });
    });
    commit('SET_POPUP',false);
  },
  async fetchUsers({ commit },statement) {
    const _users = (await firebase.database().ref(`/users`).once('value')).val();
    const users = [];
    for(const x in _users){
      users[_users[x].userId] = _users[x];
    }
    commit('SET_STATEMENT_USER',statement);
    if(statement.userId){
      firebase.firestore().collection("history").where("type", "==", "ฝาก").where('userId','==',statement.userId).where('status','==','กำลังดำเนินการ').orderBy('createdate','desc').get().then((query)=>{
        const statements = [];
        query.forEach((doc) => {
          const data = doc.data();
          data.key = doc.id;
            if(users[data.userId]){
              const user = users[data.userId];
              data.linename = user.linename;
              data.firstname = user.firstname;
              data.lastname = user.lastname;
              data.bank = user.bank;
              data.account_no = user.account_no;
              data.code = user.code;
              data.pictureUrl = user.pictureUrl;
            }
          statements.push(data);
        });
        commit('SET_USERS', statements);
      });
    }else{
      firebase.firestore().collection("history").where("type", "==", "ฝาก").where('status','==','กำลังดำเนินการ').orderBy('createdate','desc').get().then((query)=>{
          const statements = [];
          query.forEach((doc) => {
            const data = doc.data();
            data.key = doc.id;
            if(users[data.userId]){
              const user = users[data.userId];
              data.linename = user.linename;
              data.firstname = user.firstname;
              data.lastname = user.lastname;
              data.bank = user.bank;
              data.account_no = user.account_no;
              data.code = user.code;
              data.pictureUrl = user.pictureUrl;
            }
            statements.push(data);
          });
          commit('SET_USERS', statements);
      });
    }
    
  },
  async fetchStatement ({ commit,state }) {
    const _users = (await firebase.database().ref(`/users`).once('value')).val();
    const users = [];
    for(const x in _users){
      users[_users[x].userId] = _users[x];
    }
    let statements = (state.statement.length>0)?state.statement:[];
    firebase.firestore().collection("krungsri").where("type", "==", "ฝาก").orderBy('date','desc')
    .onSnapshot((snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            const statement = change.doc.data();
            if(users[statement.userId]){
              const user = users[statement.userId];
              statement.key = change.doc.id;
              statement.linename = user.linename;
              statement.firstname = user.firstname;
              statement.lastname = user.lastname;
              statement.bank = user.bank;
              statement.account_no = user.account_no;
              statement.code = user.code;
              statement.pictureUrl = user.pictureUrl;
              statement.createdate = statement.date;
              statements.push(statement);
            }else{
              statement.key = change.doc.id;
              statement.linename = '';
              statement.firstname = '';
              statement.lastname = '';
              statement.account_no = statement.bank;
              statement.bank = '';
              statement.code = '';
              statement.pictureUrl = '';
              statement.createdate = statement.date;
              statements.push(statement);
            }
          }
          if (change.type === "modified") {
              const value = change.doc.data();
              const keyUser = _.findKey(statements, function(o) { return o.key === change.doc.id; });
              if(keyUser){
                const statement =  statements[keyUser];
                statement.qty = value.qty;
                statement.status = value.status;
                statement.updatetime = moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss");
                statement.createdate = value.date;
                statements.splice(keyUser, 1);
                statement.key = change.doc.id;
                statements.splice(keyUser, 0, statement);
              }
          }
        });
        if(statements.length > 0){
          statements = _.orderBy(statements, ['createdate'],['desc']);
          commit('SET_STATEMENT', statements);
        }
    });
    //commit('SET_USERS', []);
  },
  /*updateUsers({state,commit}, {key,value}){
    console.log(key);
    console.log(value);
    console.log(state.users);
    const users = state.users;
    const keyUser = _.findKey(users, function(o) { return o.key === key; });
    if(keyUser){
      users.splice(keyUser, 1);
      value.key = key;
      users.splice(keyUser, 0, value);
      commit('SET_USERS', users);
    }
  },*/
}
